export default {
  name: 'Approvers',
  props: {
    data: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      showDecisionComments: false
    }
  },
  methods: {
    getStatus (index) {
      let className = null;
      let textCode = null;
      if (this.data[index].approved) {
        className = 'text-success';
        textCode = 'approved';
      } else if (this.data[index].rejected) {
        className = 'text-danger';
        textCode = 'rejected';
      } else {
        className = 'text-black';
        textCode = 'waiting';
      }

      const translation = this.$t('approvers.statuses.' + textCode);
      return `<span class='${className}'>${translation}</span>`;
    },
    toggleShowDecisionComments () {
      this.showDecisionComments = !this.showDecisionComments
    }
  }
}
